<template id="header">
    <div class="suspension">
        <div class="suspensionLi">
            <img src="@/assets/suspension/shopping.png" alt="">
	        <div class="suspensionInfo">
		        <img class="code" src="@/assets/suspension/taobao.png" alt="">
		        <span class="cart"></span>
	        </div>
        </div>
        <div class="suspensionLi">
            <img src="@/assets/suspension/code.png" alt="">
            <div class="suspensionInfo">
                <img class="code" src="@/assets/suspension/codeMax.jpg" alt="">
                <span class="cart"></span>
            </div>
        </div>
        <div class="suspensionLi">
            <img src="@/assets/suspension/phone.png" alt="">
            <div class="suspensionInfo trans2">
                <span class="phone">400-001-0224</span>
                <span class="cart"></span>
            </div>
        </div>
        <div class="suspensionLi" @click="topScroll">
            <img src="@/assets/suspension/jt.png" alt="">
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                scrollTop: 0
            }
        },
        methods:{
            topScroll(){
                window.scrollTo(0, 0);
            },
            navLiDown(num){
                this.headerNav = num;
                this.$store.commit({
                  type: "setNavIndex",
                  num: this.headerNav
                })
                localStore.save(num)
            }
        },
        mounted () {

        }
    }
</script>
<style scoped>
    .suspension{
        width: 43px;
        height: 232px;
        position: fixed;
        top: 50%;
        margin-top: -116px;
        right: 31px;
        z-index: 10;
    }
    .suspensionLi{
        width: 100%;
        height: 43px;
        background: #666;
        border-radius: 5px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .suspensionLi:last-child{
        margin-bottom: 0;
    }
    .suspensionLi:hover{
        background: #2091f1;
    }
    .suspensionLi:hover .suspensionInfo{
        width: auto;
        display: block;
    }
    .suspensionInfo{
        width: 0%;
        background: #fff;
        position: absolute;
        right: 60px;
        border-radius: 5px;
        color: #333;
        font-size: 18px;
        display: none;
        box-shadow: 0 0 5px rgba(0,0,0,.2);
        white-space: nowrap;
    }
    .code{
        width: 130px;
    }
    .suspension .code,.suspension .phone{
        display: block;
        margin: 10px;
    }
    .cart{
        display: inline-block;
        width: 0;
        height: 0;
        border: 7px solid #fff;
        margin-right: 6px;
        vertical-align: middle;
        border-color: transparent;
        border-left-color: #fff;
        position: absolute;
        right: -20px;
        top: 50%;
        margin-top: -7px;
    }
    .suspensionLi>a>img,.suspensionLi>img{
        display: block;
    }
    @media (max-width: 1600px) {
        .suspension{
            width: 30px;
            height: 165px;
            margin-top: -83px;
            right: 25px;
        }
        .suspensionLi{
            height: 30px;
            margin-bottom: 15px;
        }
        .suspensionLi>a>img,.suspensionLi>img{
            width: 16px;
            display: block;
        }
        .code{
            width: 105px;
        }
        .suspensionInfo {
            right: 48px;
            font-size: 16px;
        }
    }
    @media (max-width: 960px) {
        .suspension{
            width: 40px;
            height: auto;
            margin: 0;
            top: inherit;
            right: 15px;
            bottom: 41px;
        }
        .suspensionLi{
            height: 40px;
            margin-bottom: 10px;
        }
        .suspensionLi>a>img, .suspensionLi>img{
            width: 20px;
        }
        .suspensionInfo{
            right: 55px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/suspension/suspension.vue